import { TriangleAlert } from 'lucide-react';
import { PILL, PILL_COLORS } from './helper';

const SectionRow = ({ label, value, warn = false, half = false }) => (
  <div className={`py-3 ${half ? '' : 'col-span-2'} ${Array.isArray(value) ? '' : 'border-b border-gray-100 last:border-0'}`}>
    <p className="text-xs text-secondary-400">{label}</p>

    {Array.isArray(value) ? (
      <div className="mt-1.5 flex flex-wrap gap-2">
        {value.map((item) => (
          <span key={item} title={item} className={`${PILL} ${warn ? PILL_COLORS.warn : PILL_COLORS.default}`}>
            {warn && <TriangleAlert size={12} className="shrink-0" />}
            <span className="truncate">{item}</span>
          </span>
        ))}
      </div>
    ) : (
      <p className="mt-0.5 break-words text-[13px] font-semibold text-secondary-900">{value}</p>
    )}
  </div>
);

export default SectionRow;
